import styled from 'styled-components';
import {ContentStyled} from '../../styles/components/content.style';
import {media} from '../../styles/components/media-queries';

export const ContactPageContentWrapperStyled = ContentStyled.extend`
  background: ${props => props.theme.contactPage.backgroundColor};
  text-align: left;
  font-size: ${props => props.theme.contactPage.fontSize};
  width: ${props => props.theme.contactPage.width};
  margin-top: ${props => props.theme.contactPage.offsetTop};
  ${media.small`
    width: 100%;
    margin: 0;
  `};
  a {
    color: ${props => props.theme.contactPage.linkColor || props.theme.linkColor};
  }
`;

export const OpeningTimesTable = styled.table`
  width: 100%;
`;

const MAP_HEIGHT = '20rem';

export const MapContainerStyled = styled.div`
  width: 100%;
  height: ${MAP_HEIGHT};
`;

export const DayOfTheWeek = styled.td`
  width: 12rem;
  vertical-align: top;
  text-transform: capitalize;
`;



// WEBPACK FOOTER //
// ./containers/ContactPage/ContactPage.style.js